<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>购物车</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="bGColorWhite padding-b-10">
        <div class="title">收货地址</div>
        <div class="flex-justify">
          <div class="name">姓名：</div>
          <div class="input-box">
            <input
              class="input"
              v-model="ship_username"
              placeholder="请输入姓名"
            />
          </div>
        </div>
        <div class="flex-justify">
          <div class="name">手机号：</div>
          <div class="input-box">
            <input
              class="input"
              v-model="ship_phone"
              placeholder="请输入手机号"
            />
          </div>
        </div>
        <div class="flex-justify">
          <div class="name">地址：</div>
          <div class="input-box">
            <input class="input" v-model="ship_addr" placeholder="请输入地址" />
          </div>
        </div>
      </div>
      <div class="bGColorWhite">
        <div class="title">订单详情</div>
        <ul class="order-goods">
          <div v-if="cartSecletList && cartSecletList.length > 0">
            <li
              v-for="(goodsItem, goodsIndex) in cartSecletList"
              :key="goodsIndex"
            >
              <img :src="goodsItem.image" />
              <div class="goods-text">
                <h3>{{ goodsItem.goods_name }}）</h3>
                <p>{{ goodsItem.spec_key_name }}</p>
              </div>
              <div>¥{{ goodsItem.price }}</div>
              <div>x {{ goodsItem.buy_num }}</div>
            </li>
          </div>
          <div v-if="goodsDetail && cartSecletList.length == 0">
            <li>
              <img :src="goodsDetail.image" />
              <div class="goods-text">
                <h3>{{ goodsDetail.goods_name }}）</h3>
                <p>{{ goodsNewSkuName }}</p>
              </div>
              <div>¥{{ goodsDetail.price }}</div>
              <div>x {{ goodsDetail.buy_num }}</div>
            </li>
          </div>
        </ul>
      </div>
      <div class="padding-b-10">
        <div class="title">费用详情</div>
        <div class="flex-justify" style="justify-content: space-between">
          <div class="img">商品总金额</div>
          <div class="red">￥{{ allAmount }}</div>
        </div>
      </div>
      <div class="flex submit-box">
        <div class="text">共1笔订单</div>
        <div class="pay-button" @click="goSubmitOrder">提交订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import mall from '@/api/mall';
import order from '@/api/order';
import { regexs } from '../../setup/common';
import _underScore from 'underscore';
export default {
  data() {
    return {
      goodIDs: '',
      cartSecletList: [],
      goodsDetail: {},
      goodsNewSkuName: '',
      allAmount: '0.00',
      ship_username: '', //收货人姓名
      ship_phone: '', //收货人手机号
      ship_addr: '', //收货人地址
      merchant_code: '',
    };
  },
  created() {
    if (this.$route.query.goodsDetail) {
      //立即购买
      this.goodsDetail = JSON.parse(this.$route.query.goodsDetail);
      console.log('立即购买', JSON.stringify(this.goodsDetail));
      this.allAmount = (
        this.goodsDetail.buy_num * this.goodsDetail.price
      ).toFixed(2);
      this.goodsNewSkuName = this.goodsDetail.sku_name_arr.join();
      this.goodIDs =
        this.goodsDetail._id +
        '_' +
        this.goodsDetail.goods_id +
        '_' +
        this.goodsDetail.buy_num;
      //this.merchant_code = this.goodsDetail.merchant_code;
    } else {
      this.goodIDs = this.$route.query.ids;
      let getCartList = JSON.parse(this.$route.query.cartList);
      this.getSelectCartList(getCartList);
      this.getAllMount(getCartList);
    }
  },
  methods: {
    getSelectCartList(carList) {
      for (let i = 0; i < carList.length; i++) {
        for (let k = 0; k < carList[i].glist.length; k++) {
          if (carList[i].glist[k].selected == true) {
            this.cartSecletList.push(carList[i].glist[k]);
          }
        }
      }
    },
    getAllMount(cartList) {
      //计算选中总价
      var that = this;
      let allPrice = 0;
      for (let i = 0; i < cartList.length; i++) {
        for (let k = 0; k < cartList[i].glist.length; k++) {
          if (cartList[i].glist[k].selected == true) {
            allPrice =
              allPrice +
              cartList[i].glist[k].buy_num * cartList[i].glist[k].price;
          }
        }
      }
      that.allAmount = allPrice.toFixed(2);
    },
    async goSubmitOrder() {
      if (!this.ship_username) {
        alert('请输入收货人姓名');
        return;
      }
      if (!this.ship_phone) {
        alert('请输入收货人手机号');
        return;
      }
      if (!regexs.allphone.test(this.ship_phone)) {
        alert('请输入正确的手机号');
        return;
      }
      if (!this.ship_addr) {
        alert('请输入收货人地址');
        return;
      }
      await order.relateMerchant({
        // place_code: "S0028151",
        merchant_code: process.env.VUE_APP_MALL_MERCHANT_CODE, //'120738', //TODO
      });
      const submitOrderGet = await mall.getSubmitOrder({
        goods_ids: this.goodIDs,
        username: this.ship_username,
        ship_username: this.ship_username,
        ship_addr: this.ship_addr,
        ship_zip: '10010',
        ship_phone: this.ship_phone,
      });
      console.log('清空购物车', this.goodsDetail, this.cartSecletList);
      if (!this.goodsDetail || this.cartSecletList.length > 0) {
        // cart.removeAllCart();
        this.$store.commit('removeAllCart');
        console.log('清空购物车');
      }
      this.$router.push({
        path: '/account/mall-order',
      });
      sessionStorage.setItem('comeFrom', 'submitOrder');
    },
  },
};
</script>

<style lang="less" scoped>
div {
  width: auto;
}
.content {
  width: 1100px;
  margin: 20px auto;
  padding: 20px 20px;
  background: #fff;
}
.padding-t-10 {
  padding-top: 10px;
}
.margin-b-20 {
  margin-bottom: 20px;
  background-color: #fff;
}
.bGColorWhite {
  background-color: #fff;
}
.margin-b-100 {
  margin-bottom: 100px;
  background-color: #fff;
}
.title {
  margin-bottom: 10px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e4e4;
  font-weight: bold;
  line-height: 40px;
}
.flex-justify {
  display: flex;
  padding: 7px 20px;
  line-height: 40px;
  .name {
    width: 100px;
  }
  .input-box {
    flex: 1;
    .input {
      width: 340px;
      height: 40px;
      padding: 0 20px;
      border: 1px solid #e4e4e4;
      line-height: 40px;
      outline: none;
    }
  }
  .img {
    width: 200px;
    img {
      max-width: 100%;
      height: 200px;
    }
  }
  .text {
    flex: 1;
  }
}
.submit-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px 0 20px;
  border-top: 1px solid #e4e4e4;
  line-height: 60px;
  background-color: #f8f8f8;
  .pay-button {
    height: 36px;
    padding: 0 30px;
    border-radius: 18px;
    color: #fff;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    background: #00a2ea;
    background: #31a775;
    cursor: pointer;
  }
}
.red {
  display: inline-block;
}
.padding-b-10 {
  padding-bottom: 10px;
}
.order-goods {
  padding: 10px 0;
  li {
    display: flex;
    margin-bottom: 0;
    padding: 10px 20px;
    img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }
    .goods-text {
      width: 360px;
    }
    h3 {
      margin-bottom: 6px;
      font-weight: normal;
      font-size: 14px;
    }
    div {
      margin-right: 100px;
    }
  }
}
</style>
